import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect } from 'react';

const useUploadSuccessModal = (isSuccessUpload: boolean) => {
  const [isUploadSuccessModalOpen, openUploadSuccessModal, closeUploadSuccessModal] = useSwitchState();

  useEffect(() => {
    if (!isSuccessUpload) return;

    openUploadSuccessModal();
  }, [isSuccessUpload]);

  const canOpenModal = isUploadSuccessModalOpen && isMobileOrIPad();

  return [canOpenModal, closeUploadSuccessModal] as const;
};

export default useUploadSuccessModal;
